import {types} from './types';

const setGetGgrAction = (payload) => {
    return {
        type: types.SET_GGR,
        payload,
      }
}

const setGetOperationsReplenishmentAction = (payload) => {
  return {
      type: types.SET_OPERATION_REPLENISHMENT,
      payload,
    }
}

const setGetOperationsWithdrawalAction = (payload) => {
  return {
      type: types.SET_OPERATION_WITHDRAWAL,
      payload,
    }
}

export {
  setGetGgrAction,
  setGetOperationsReplenishmentAction,
  setGetOperationsWithdrawalAction
}